import { servicesApi } from '@/services/api/deprecated';
import { getSetupGuide, updateSetupGuide } from '../setup-guide/api';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { AxiosError } from 'axios';

// Attempts to get the sample broadcast, and resets the ID if none is found
export const getSampleBroadcast = async () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  if (isNaN(parseInt(String(workspaceId)))) {
    return null;
  }
  const setupGuide = await getSetupGuide(workspaceId);
  const sampleBroadcastId = setupGuide?.setup_guide.sample_newsletter_id;
  const sampleTemplateId = setupGuide?.setup_guide.sample_template_id;

  if (isNaN(parseInt(String(sampleBroadcastId))) || isNaN(parseInt(String(sampleTemplateId)))) {
    return null;
  }

  try {
    const { data } = await servicesApi.get(
      `/environments/${workspaceId}/newsletters/${sampleBroadcastId}/templates/${sampleTemplateId}`,
    );
    return data;
  } catch (error: unknown) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      updateSetupGuide(workspaceId as number, {
        ...setupGuide?.setup_guide,
        sample_newsletter_id: undefined,
        sample_template_id: undefined,
      });
    }
  }
};
